import { css } from '@emotion/react';
import { semantic_colors } from '../../foundation';
import { getAutoColorCode } from '../../styles';

export const top_bar_action_button_css = css`
  display: flex;
  align-items: center;
  position: relative;
  color: ${semantic_colors.content.primary_inverse};
  &:hover {
    color: ${getAutoColorCode(semantic_colors.content.primary_inverse).hover};
    background-color: ${getAutoColorCode(semantic_colors.background.surface_inverse).hover};
  }
  &:active {
    color: ${getAutoColorCode(semantic_colors.content.primary_inverse).pressed};
    background-color: ${getAutoColorCode(semantic_colors.background.surface_inverse).pressed};
  }
`;
